import { Component, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Router } from "@angular/router";
import {
  WeGoConfig,
  DataListModel,
  ApplicationRouteURL
} from "../../shared/config";
import { RoleService } from "../models/role.service";
import { RoleModel } from "../models/role.model";
import { AuthService } from "../../shared/models/auth.service";
import { TranslateService } from "../../shared/translate/index";
import { ModalDirective } from 'ng2-bootstrap/components/modal';

@Component({
  selector: "wego-role",
  template: require('../views/role-list.component.html') + WeGoConfig.APP_VERSION,
  providers: [RoleService]
})
export class RoleListComponent implements OnInit {
  DataListModel: DataListModel;
  roleList: RoleModel[];
  apiErrorMsg: string;
  isLoading: boolean;
  urlDefaultPage: string;
  urlRoleUpdate: string;
  deleteRoleHashId: string;

  private popupMsg: string;
  private module: string;
  private breadCrumbList: string;
  private popupTitle: string;
  private validationMessage: string;

  @ViewChild("confirmModal") public confirmModal: any;
  @ViewChild("successPopup") public successPopup: any;
  @ViewChild("alertModal") public alertModal: ModalDirective;

  constructor(
    private roleService: RoleService,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.module = this.translate.instant("LblRoleManagement");
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["roleName", "entity", "roleType"];
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlRoleUpdate = this.authService.GetURL(
      ApplicationRouteURL.URL_ROLE_UPDATE
    );
    this.GetRoleList();
    this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
  }

  public GetRoleList(): any {
    this.isLoading = true;
    this.roleService.GetRoleList(this.DataListModel).subscribe(
      res => {
        this.roleList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.roleService.ExportRoleList(this.DataListModel).subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "Role" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetRoleList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      event.searchTerm,
      event.isReset
    );
    this.GetRoleList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetRoleList();
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetRoleList();
  }

  public ShowConfirmModal(roleHashId?: string): void {
    this.deleteRoleHashId = roleHashId;
    this.popupMsg = this.translate.instant("LblRecordDeleteConfirmation", [
      this.module
    ]);
    this.deleteRoleHashId = roleHashId;
    this.confirmModal.show();
  }

  public HideConfirmModal(): void {
    this.deleteRoleHashId = "";
    this.confirmModal.hide();
  }

  public SuccessModalClick(): void {
    this.DeleteRole(this.deleteRoleHashId);
    this.confirmModal.hide();
  }

  public DeleteRole(deleteRole: string) {
    this.isLoading = true;
    this.roleService.DeleteRole(deleteRole).subscribe(
      res => {
        if (res.data) {
          this.DataListModel.currentPage = 1;
          this.GetRoleList();
          this.popupMsg = this.translate.instant("LblRecordRemovedSuccess", [
            this.module
          ]);
          this.ShowSuccessPopup();
        } else {
          this.validationMessage = res.error;
          this.popupTitle = this.translate.instant("LblWarning");
          this.ShowAlertModal();
        }
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
  public SuccessAlertModalClick(): void {
    this.alertModal.hide();
  }
  public ShowAlertModal(): void {
    this.isLoading = false;
    this.alertModal.show();
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/role-management/components/role-list.component.ts